import React from 'react';

import { HN_SKJEMA_FRONTEND_RESOURCES } from 'src/constants/constants';
import { useGetSkjemaErrorTitleAndBodyFromResources } from 'src/hooks/useGetSkjemaErrorTitle';
import { useResources } from 'src/resources';
import { useAppDispatch, useAppSelector } from 'src/store/reducers';
import { dismissSendInnError } from 'src/store/reducers/uiSlice';

import type { HNSkjemaFrontend } from 'src/types/Resources';

import Modal from '@helsenorge/designsystem-react/components/Modal';

export const SendInnSkjemaErrorModal = (): React.JSX.Element | null => {
  const dispatch = useAppDispatch();
  const sendInnSkjemaError = useAppSelector(state => state.refero.ui.sendInnSkjemaError);
  const sendInnSkjemaErrorCode = useAppSelector(state => state.refero.ui.sendInnSkjemaErrorCode);

  const errorTekst = useGetSkjemaErrorTitleAndBodyFromResources({
    bodyKey: 'sendInnSkjemaErrorBody',
    titleKey: 'sendInnSkjemaErrorTitle',
    error: sendInnSkjemaError,
    errorCode: sendInnSkjemaErrorCode,
  });
  const resources = useResources<HNSkjemaFrontend>(HN_SKJEMA_FRONTEND_RESOURCES);

  const confirmationActionButton = resources?.confirmationActionButton;
  const onSendInnErrorClose = (): void => {
    dispatch(dismissSendInnError());
  };

  return sendInnSkjemaError && errorTekst ? (
    <Modal
      variant="error"
      testId="send-inn-skjema-error"
      onClose={onSendInnErrorClose}
      title={errorTekst?.errorTitle}
      description={errorTekst?.errorBody}
      onSuccess={onSendInnErrorClose}
      primaryButtonText={confirmationActionButton}
    />
  ) : null;
};
export default SendInnSkjemaErrorModal;
